import { useQuery } from "@tanstack/react-query";

import { getChallengesForEmployee } from "../../../../api/getChallengesForEmployee";
import { useSalesContext } from "../../../../sales-context/SalesContext";

export const useChallenges = () => {
    const { logger, partner, apiClients } = useSalesContext();
    const childLogger = logger.child({ module: "useChallenges", supportTeam: "sales" });

    const { data, isLoading, isError, isFetching } = useQuery({
        queryKey: [`get-challenge`, partner],
        queryFn: async () => {
            childLogger.info("Fetching challenges for this participant");
            try {
                const result = await getChallengesForEmployee(apiClients.gamification, childLogger, partner);
                childLogger.info({ challengeCount: result?.length ?? 0 }, "Successfully fetched challenges");
                return result;
            } catch (error) {
                childLogger.warn({ error }, "Failed to fetch challenges");
                throw error;
            }
        },
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: 1,
    });
    return { data, isLoading, isError, isFetching };
};
